import { LegalConsentOptions } from './legal-consent/legal-consent-options.model';

export interface IFormSubmissionData {
    fields: { [key: string]: string };
    LegalConsentOptions: LegalConsentOptions;
}

export class FormSubmissionData {
    fields: { [key: string]: string };
    LegalConsentOptions: LegalConsentOptions;

    constructor(config?: IFormSubmissionData) {
        this.fields = config?.fields ?? {};
        this.LegalConsentOptions = config?.LegalConsentOptions ?? new LegalConsentOptions();
    }
}
